// Copyright © Veeam Software Group GmbH
/* eslint-disable */
// Autogenerated

export enum OperatorScopeType {
    User = 0,
    Web = 1,
    Team = 2
}
